export const ADD_PAGE = 'ADD_PAGE';
export const ADD_TILES = 'ADD_TILES';
export const ADD_FLAG_IS_APP_VIEW = 'ADD_FLAG_IS_APP_VIEW';
export const ADD_FLAG_VISITED_RENEWAL_PAGE = 'ADD_FLAG_VISITED_RENEWAL_PAGE';
export const ADD_FLAG_EXIT_PAGE_POPUP_DISPLAYED = 'ADD_FLAG_EXIT_PAGE_POPUP_DISPLAYED';
export const TOGGLE_BATTERY_REPLACE_REMOVED_POPUP = 'TOGGLE_BATTERY_REPLACE_REMOVED_POPUP';
export const SET_REFRESH_VEHICLES_LIST = 'SET_REFRESH_VEHICLES_LIST';

export const DOWNGRADE_POPUP_STATUS = {
  NOT_DISPLAYED: 'NOT_DISPLAYED',
  SHOW: 'SHOW',
  REDIRECT: 'REDIRECT',
  DISPLAYED: 'DISPLAYED',
};
